let LocalStorage = typeof localStorage !== 'undefined' ? localStorage : {getItem: () => {return "{}"}, setItem: () => {}}

export default LocalStorage